import { render, staticRenderFns } from "./Collector.vue?vue&type=template&id=71171f73"
import script from "./Collector.vue?vue&type=script&lang=js"
export * from "./Collector.vue?vue&type=script&lang=js"
import style0 from "./Collector.vue?vue&type=style&index=0&id=71171f73&prod&lang=scss"
import style1 from "vue-select/dist/vue-select.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports